import { Component, OnInit } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-account-expired',
  templateUrl: './expired.component.html',
  styleUrls: ['./expired.component.scss']
})
export class ExpiredComponent implements OnInit {

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    //console.log("Expired");
  }

}
